import React from 'react';
import { Link } from 'react-router-dom';
import ProductInfo from './ProductInfo';
import ProductImage from './ProductImage';
import DeleteButton from './DeleteButton';
import useProductCard from '../hooks/useProductCard';

const CustomerProductCard = ({ product, index, user, gold, translate, onDelete, deleteThisProductId }) => {
  const { discounted, product_price_without, productUrl } = useProductCard({ product, gold });
  console.log({ product });
  const isDeleting = deleteThisProductId === product['customers_basket_id'];

  return (
    <div className='product-card'>
      <div className='product-wrapper'>
        <Link target='_blank' to={productUrl} className='product-content' style={{ textDecoration: 'none', color: 'inherit', paddingRight: '1rem' }}>
          <ProductInfo product={product} index={index} user={user} discounted={discounted} product_price_without={product_price_without} translate={translate} />

          <ProductImage product={product} discounted={discounted} />
        </Link>

        <DeleteButton productId={product['customers_basket_id']} onDelete={onDelete} isDeleting={isDeleting} variant='icon' translate={translate} />
      </div>
    </div>
  );
};

export default CustomerProductCard;
